<template>
  <div ref="container" class="d-flex flex-wrap">
    <datepicker
      v-if="show.date"
      id="date"
      ref="date"
      v-model="selected.date"
      placeholder="Date"
      format="D dd MMM yyyy"
      calendar-class="datepicker datepicker-dropdown dropdown-menu"
      :bootstrap-styling="true"
      :class="datePickerClass"
      :disabled="disabled"
      @change="updateSelectedTime"
    />
    <b-form-select
      v-if="show.time"
      id="hrs"
      ref="hrs"
      v-model="selected.hr"
      class="w-100px mr-2"
      :options="hrs"
      :disabled="disabled"
      @change="updateSelectedTime"
    />
    <b-form-select
      v-if="show.time"
      id="minutes"
      ref="minutes"
      v-model="selected.min"
      class="w-100px mr-2"
      :options="minutes"
      :disabled="disabled"
      @change="updateSelectedTime"
    >
    </b-form-select>

    <b-form-select
      v-if="show.time"
      id="seconds"
      ref="seconds"
      v-model="selected.second"
      class="w-100px mr-2"
      :options="seconds"
      :disabled="disabled"
      @change="updateSelectedTime"
    />

    <b-form-select
      v-if="show.time"
      id="meridiem"
      ref="meridiem"
      v-model="selected.meridiem"
      class="w-100px mr-2"
      :options="meridiem"
      :disabled="disabled"
      @change="updateSelectedTime"
    />
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  name: 'BaseDatePicker',

  components: {
    Datepicker
  },

  mixins: [datetimeMixin],

  props: {
    existedData: {
      type: [String, Date],
      default: ''
    },

    datePickerClass: {
      type: String,
      default: 'w-100'
    },

    show: {
      type: Object,
      default: () => ({
        date: true,
        time: true
      })
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: {
        date: null,
        day: 'Monday',
        hr: '09',
        min: '00',
        second: '00',
        meridiem: 'am',
        time: '09:00:00 am'
      }
    };
  },

  computed: {
    hrs() {
      return this.generateNumber(2, 26);
    },
    minutes() {
      return this.generateNumber(0, 120);
    },
    seconds() {
      return this.generateNumber(0, 120);
    },
    meridiem() {
      return ['am', 'pm'];
    },
    determineDatetime() {
      let selected = null;

      if (this.selected.date && this.selected.time) {
        selected = moment(
          `${this.formatedDatetime(this.selected.date, 'MM/DD/YYYY')} ${this.selected.time}`,
          'MM/DD/YYYY hh:mm:ss a'
        )
          .tz(this.userTimezone)
          .format();
      }

      return { selected };
    }
  },

  watch: {
    determineDatetime: {
      handler(determineDatetime) {
        if (determineDatetime) {
          this.$emit('emitDate', determineDatetime.selected);
        }
      }
    },

    existedData: {
      immediate: true,
      handler: 'init'
    }
  },

  methods: {
    updateSelectedTime() {
      this.$set(
        this.selected,
        'time',
        `${this.selected.hr}:${this.selected.min}:${this.selected.second} ${this.selected.meridiem}`
      );
    },

    init(existedData) {
      if (existedData) {
        const date = new Date(existedData);

        const hr =
          date.getHours() === 0
            ? '12'
            : date.getHours() > 12
            ? (date.getHours() - 12).toString()
            : date.getHours().toString();

        const min = date.getMinutes() === 0 ? '00' : date.getMinutes().toString();

        const second = date.getSeconds() === 0 ? '00' : date.getSeconds().toString();

        const meridiem = date.getHours() >= 12 ? 'pm' : 'am';

        this.$set(this.selected, 'date', date);
        this.$set(this.selected, 'hr', hr.length === 1 ? `0${hr}` : hr);
        this.$set(this.selected, 'min', min.length === 1 ? `0${min}` : min);
        this.$set(this.selected, 'second', second.length === 1 ? `0${second}` : second);
        this.$set(this.selected, 'meridiem', meridiem);

        this.updateSelectedTime();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.w-100px {
  width: 100px !important;
}

::v-deep .datepicker header .prev {
  margin-top: 12px;
  margin-bottom: 12px;
  width: 28px;
  margin-right: 8px;
  height: 16px;
  content: url('../../assets/chevron-left-solid.svg') !important;
}

::v-deep .datepicker header .next {
  margin-top: 12px;
  margin-bottom: 12px;
  width: 28px;
  margin-right: 8px;
  height: 16px;
  content: url('../../assets/chevron-right-solid.svg') !important;
}
</style>
